import React from 'react';
import QuestionSvg from 'assets/question.svg';
import FastTransactionsImg from 'assets/back-cash-money_svgrepo.com.svg';
import LowFeesImg from 'assets/statistic-low_svgrepo.com.svg';
import SecureImg from 'assets/secure-card_svgrepo.com.svg';
import PaymentMethodsImg from 'assets/add-payment-card_svgrepo.com.svg';
import Lottie from 'lottie-react';
import QuestionLottie from 'assets/lottie/question.json';

export const WhyChooseWire24 = () => {
  return (
    <div className="w-full py-12 px-6 md:px-16">
      <div className="py-20 mx-auto">
        {/* Main Section */}
        <div className="flex flex-col md:flex-row items-center mb-12 md:py-48">
          {/* Question SVG */}
          {/* <img src={QuestionSvg} alt="Why Choose Us" className="w-32 h-32 md:w-48 md:h-48" /> */}
          <Lottie animationData={QuestionLottie} loop className="w-50[vw]" />
          {/* Content */}
          <div className="md:ml-8 text-center md:text-left">
            <h2 className="text-3xl text-right md:text-5xl font-bold mb-4">Why Choose Wire24?</h2>
            <p className="font-semibold text-right text-gray-600 mb-6 text-lg md:text-xl">
              Your 24/7 Gateway to Seamless Global Transfers
            </p>
            <p className="text-gray-700 text-right text-lg md:text-xl mb-4">
              Wire24 isn’t just a transfer service—it’s your trusted partner for fast, secure, and
              affordable money transfers, anytime, anywhere. With cutting-edge technology, zero
              hidden fees, and support for multiple payment methods, Wire24 delivers money instantly
              and securely to your loved ones across the globe.
            </p>
            <p className="text-gray-700 text-right text-lg md:text-xl">
              Join thousands who trust Wire24—because your money should move as fast as you do.
            </p>
          </div>
        </div>

        {/* Features Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {/* Feature 1 */}
          <div className="flex items-start">
            <img src={FastTransactionsImg} alt="Fast Transactions" className="w-12 h-12 mr-4" />
            <div>
              <h3 className="text-xl font-semibold mb-2">Fast Transactions</h3>
              <p className="text-gray-600 text-lg md:text-xl">
                Send money instantly with real-time processing. With Wire24, your transfers arrive
                in seconds, not days
              </p>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="flex items-start">
            <img src={LowFeesImg} alt="Low Fees & Great Rates" className="w-12 h-12 mr-4" />
            <div>
              <h3 className="text-xl font-semibold mb-2">Low Fees & Great Rates</h3>
              <p className="text-gray-600 text-lg md:text-xl">
                Get more value for your money with competitive rates and zero hidden fees. Wire24
                keeps your transfers transparent and affordable.
              </p>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="flex items-start">
            <img src={SecureImg} alt="Secure & Reliable" className="w-12 h-12 mr-4" />
            <div>
              <h3 className="text-xl font-semibold mb-2">Secure & Reliable</h3>
              <p className="text-gray-600 text-lg md:text-xl">
                Your money is protected with bank-grade encryption and advanced security
                protocols—because your safety comes first
              </p>
            </div>
          </div>

          {/* Feature 4 */}
          <div className="flex items-start">
            <img
              src={PaymentMethodsImg}
              alt="Multiple Payment Methods"
              className="w-12 h-12 mr-4"
            />
            <div>
              <h3 className="text-xl font-semibold mb-2">Multiple Payment Methods</h3>
              <p className="text-gray-600 text-lg md:text-xl">
                More ways to pay, more ways to receive. From mobile money to bank transfers, Wire24
                offers flexible options to suit your needs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
